import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { fetchAccount } from 'api/account';
import { useCurrentAccountId } from 'customHooks/useCurrentAccountId';
import { Settings } from 'luxon';
import { accountQueryKeys } from 'queries/account-query-keys';

const useInitCurrentAccount = () => {
    const queryClient = useQueryClient();
    const accountId = useCurrentAccountId();

    return useSuspenseQuery({
        queryKey: accountQueryKeys.init(),
        queryFn: async () => {
            await queryClient.prefetchQuery({
                queryKey: accountQueryKeys.current(accountId),
                queryFn: async () => {
                    const account = await fetchAccount(accountId);
                    Settings.defaultZone = account.data.timezone;

                    return account;
                },
            });

            return Promise.resolve(true);
        },
        staleTime: Infinity,
        retry: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
    });
};

export { useInitCurrentAccount };
